import StateInterface from "../state-interface";

export const accountsetting_snackbar: StateInterface["accountsetting_snackbar"] =
  {
    kyc_snackbar: false,
    subscription_snackbar: false,
    cancel_subscription_snackbar: false,
    personalinfo_snackbar: false,
  };
